export const featuredProject = [
    {
      id: 1,
      title: "Search Engine",
      img: require("./assets/1.PNG"),
      URL: "https://findrnow.netlify.app/search",
    },
    {
      id: 2,
      title: "Crypto Monitoring",
      img: require("./assets/2.png"),
      URL: "",
    },
  ];
  
  export const webProject = [
    {
      id: 1,
      title: "Crypto Dashboard",
      img: require("./assets/3.png"),
    }
  ];
  